import React, { useState, useEffect, Fragment, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import axios from 'axios';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { warehouses } from '../common/constants';
import {addressCharLimits, filterNotes, validateRegion} from '../common/handleAddress';
import ButtonLoading from './ButtonLoading';
import DropdownCountry from './DropdownCountry';
import DropdownRegion from './DropdownRegion';
import RecaptchaV2 from './RecaptchaV2/recaptchaV2';
import { Collapse } from 'antd';
import agent from "../api/agent";
const { Panel } = Collapse;

const plans = [
  {
    name: 'Free',
    value: 212
  },
  {
    name: 'Gold',
    value: 213
  },
  {
    name: 'Platinum',
    value: 215
  },
]

const mapStateToProps = (globalStore) => {
  return { store: globalStore };
};

const PublicCalculator = (props) => {
  const [plan, setPlan] = useState(212)
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [reinitAttempted, setReinitAttempted] = useState(false);
  const [weightMetric, setWeightMetric] = useState(0);
  const [dimensionsMetric, setDimensionsMetric] = useState(0);
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');
  const [warehouse, setWarehouse] = useState(0);
  const [city, setCity] = useState('');
  const [stateCode, setStateCode] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [isRecaptcha2Required, setIsRecaptcha2Required] = useState(false);
  const [recaptchaV2Response, setRecaptchaV2Response] = useState('');
  const [shippingOptions, setShippingOptions] = useState([]);
  const [userInput, setUserInput] = useState('')
  const [displayText, setDisplayText] = useState('')
  const [isTyping, setIsTyping] = useState(false);
  const [activePanel, setActivePanel] = useState('1');
  const [cleanupMessage, setCleanupMessage] = useState('')
  const [warehouseNew, setWarehouseNew] = useState(1)
  const [listType, setListType] = useState(1)

  useEffect(() => {
    setIsRecaptcha2Required(false);
  }, [countryCode]);

  const isOversized = () => {
    let dimensions = [length * 1, width * 1, height * 1];
    let longest = Math.max(...dimensions);
    dimensions.splice(dimensions.indexOf(longest), 1);
    let total = longest + (dimensions[0] + dimensions[1]) * 2;
    return dimensionsMetric ? total > 330 : total > 130;
  };

  const recaptchaV3Validate = async () => {
    try {
      return await props.googleReCaptchaProps.executeRecaptcha('estimate')
    } catch (e) {
      setMessage('Recaptcha Error :(');
    }
  }

  const doRequestQuotes = async () => {
    if (!warehouse) {
      setMessage('Please select a Reship location');
    } else if (!city || !countryCode || !postalCode) {
      setMessage('Please fill in the address');
    } else if (!validateRegion(countryCode, stateCode)) {
      setMessage('Please select a valid state/region');
    } else if (!length || !width || !height) {
      setMessage('Please fill in the dimensions');
    } else if (
      dimensionsMetric
        ? length > 300 || width > 300 || height > 300
        : length > 118 || width > 118 || height > 118
    ) {
      setMessage(
        'Sorry, maximum length, width, or height is 300 cm / 118 inches. Even so, many carriers may not support it.'
      );
    } else if (!weight) {
      setMessage('Please fill in a weight');
    } else if (weightMetric ? weight > 250 : weight > 550) {
      setMessage(
        'Sorry, maximum weight is 250 kg / 550 lb. Even so, many carriers may not support it.'
      );
    } else if (isNaN(length) || isNaN(width) || isNaN(height) || isNaN(weight)) {
      setMessage('Please enter only numbers for package details');
    } else {
      setLoading(true);

      const recaptchaV3Response = await recaptchaV3Validate()
      const postData = {
        warehouse,
        length: dimensionsMetric ? +(+length).toFixed(1) : +((length * 2.54).toFixed(1)),
        width: dimensionsMetric ? +(+width).toFixed(1) : +((width * 2.54).toFixed(1)),
        height: dimensionsMetric ? +(+height).toFixed(1) : +((height * 2.54).toFixed(1)),
        weight: weightMetric ? +(+weight).toFixed(2) : +((weight * 0.453592).toFixed(2)),
        address: {
          city,
          stateCode,
          countryCode,
          postalCode,
        },
        plan,
        recaptchaV2Response,
        recaptchaV3Response
      };

      await doSubmitRequest(postData)
      setLoading(false)
    }
  }

  const doSubmitRequest = async (postData) => {
    setSubmitted(false);
    setMessage('');
    setShippingOptions([]);

    try {
      let response
      if (postData.address.city === 'pickup') {
        response = await agent.shippingCalculator.getPickupQuote(postData)
        setListType(1)
      } else {
        response = await agent.shippingCalculator.publicEstimate(postData)
        setListType(2)
      }
      setSubmitted(true);
      setReinitAttempted(false);
      setShippingOptions(response.data.data);
    } catch (e) {
      setMessage(e.response.data.message)
      setIsRecaptcha2Required(true)
    }
  }

  const getAIResponse = async () => {
    if (!userInput) return
    setLoading(true)
    setIsTyping(false)
    setCleanupMessage('')
    setMessage('')
    setShippingOptions([])

    try {
      const cleanupResponse = await agent.shippingCalculator.getShippingRequestCleanup({userInput})
      const shippingRequest = cleanupResponse.data.data

      const { message } = shippingRequest

      if (message) {
        setCleanupMessage(message)
        return
      }

      const recaptchaV3Response = await recaptchaV3Validate()

      setWarehouseNew(shippingRequest.warehouse)

      const shippingEstimateWithMarginUp = {
        ...shippingRequest,
        length: (shippingRequest.length*1.2).toFixed(2),
        width: (shippingRequest.width*1.2).toFixed(2),
        height: (shippingRequest.height*1.2).toFixed(2),
        weight: (shippingRequest.weight*1.1).toFixed(2),
        recaptchaV3Response,
        recaptchaV2Response,
        plan: 215
      }

      const warehouseIndex = shippingRequest.warehouse - 1

      const responseText = `The estimates of shiping a package with dimension(L: ${shippingEstimateWithMarginUp.length} cm, W: ${shippingEstimateWithMarginUp.width} cm, H: ${shippingEstimateWithMarginUp.height} cm)
    and weight of ${shippingEstimateWithMarginUp.weight} kg from ${warehouses[warehouseIndex].name} to ${shippingRequest.address.city}, ${shippingRequest.address.countryCode} for different membership plans are ...`

      setDisplayText(responseText)
      setIsTyping(true)

      await doSubmitRequest(shippingEstimateWithMarginUp)
    } catch (e) {
      setMessage(e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const typingTextElement = useMemo(() => {
    if (!displayText.length || !isTyping) return null
    
    return (
      <div style={{maxWidth: '600px'}}>
        <TypingText text={displayText} speed={15} />
      </div>
    )
  }, [displayText, isTyping])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      getAIResponse()
    }
  }

  const onVerifyRecaptchaV2 = (response) => {
    setRecaptchaV2Response(response)
  }

  const aiForm = (
    <div>
      <div className="chat-input">
        <div className="calc-subtitle">We provide a virtual mailbox at our warehouse location, allowing you to receive packages and easily ship them worldwide.</div>
        <div className="calc-warehouses">
          <div className="apr-new-store-flags">
            {warehouses.map(w => (
              <div
                className={`apr-new-store-flag ${w.id === warehouseNew ? 'apr-new-store-flag-active' : ''}`}
                onClick={() => setWarehouseNew(w.id)}
                key={w.id}
              >
                <img className="apr-new-store-flag-img" src={`/assets/images/${w.flag}`} alt={w.name}/>
                <div className="apr-new-store-name">{w.name}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="calc-description">Please describe your shipping requirements, including the destination country and the item you want to ship. </div>
        <div className="calc-subnote">Detail address and item description are important for accurate shipping estimates</div>
        <textarea
          placeholder="E.g., I want to ship a pair of shoes from US to Canada, Vancouver"
          value={userInput}
          onChange={(e) => setUserInput(filterNotes(e.target.value))}
          onKeyDown={handleKeyDown}
          style={{height: 'auto', overflow: 'hidden'}}
          onInput={(e) => {
            e.target.style.height = 'auto'
            e.target.style.height = e.target.scrollHeight + 'px'
          }}
        ></textarea>
        <button className="btn btn-primary" onClick={getAIResponse}>{loading ?
          <ButtonLoading/> : `Get Shipping Estimates`}</button>
        {cleanupMessage && <div className="ship-quotes-none">{cleanupMessage}</div>}
      </div>
    </div>
  )

  const oldForm = (
    <div className="calc-l" style={{paTop: 0}}>
      <div className="calc-label" style={{marginTop: 0}}>Membership Plan</div>
      <table style={{marginTop: 10}}>
        <tbody>
        <tr>
          <td className="btn-toggle">
            {plans.map(type => {
              return (
                <div className={"btn " + (plan === type.value ? ' btn-selected' : '')}
                     key={'customs-' + type.name} onClick={() => setPlan(type.value)}>{type.name}
                </div>
              )
            })}
          </td>
        </tr>
        </tbody>
      </table>
      <div className="calc-subnote"> Save up to 20% more on shipping costs when on a Gold or Platinum Plan</div>
      <div className="calc-label">Package Details</div>
      <div className="calc-dimension2">
        <div className="calc-dimension">
          <input
            className="calc-input"
            placeholder="Length"
            value={length}
            onChange={(e) => setLength(e.target.value)}
          />
        </div>
        <div className="calc-dimension">
          <input
            className="calc-input"
            placeholder="Width"
            value={width}
            onChange={(e) => setWidth(e.target.value)}
          />
        </div>
        <div className="calc-dimension">
          <input
            className="calc-input"
            placeholder="Height"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
          />
        </div>
        <select
          className="calc-dropdown"
          value={dimensionsMetric}
          onChange={(e) => setDimensionsMetric(+e.target.value)}
        >
          <option value={0}>IN</option>
          <option value={1}>CM</option>
        </select>
      </div>
      {length && width && height && (
        <div className="calc-subnote">
          * Volumetric weight estimate:&nbsp;
          {weightMetric ? (
            dimensionsMetric ? (
              `${(length * width * height / 5000).toFixed(2)} kg`
            ) : (
              `${(length * 2.54 * width * 2.54 * height * 2.54 / 5000).toFixed(2)} kg`
            )
          ) : (
            dimensionsMetric ? (
              `${(length * 0.3937 * width * 0.3937 * height * 0.3937 / 139).toFixed(1)} lb`
            ) : (
              `${(length * width * height / 139).toFixed(1)} lb`
            )
          )}
          {isOversized() ?
            <span><br/>**Oversized - some carriers may not accept, or charge significantly more</span> : ''}
        </div>
      )}
      <div className="calc-weight">
        <input
          className="calc-input"
          placeholder="Weight"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
        />
        <select
          className="calc-dropdown"
          value={weightMetric}
          onChange={(e) => setWeightMetric(+e.target.value)}
        >
          <option value={0}>LB</option>
          <option value={1}>KG</option>
        </select>
      </div>
      <div className="calc-label">Reshipped to...</div>
      <DropdownCountry
        className="form-control"
        autoComplete="country"
        name="country"
        value={countryCode}
        onChange={(val) => {
          if (val !== countryCode) {
            setCountryCode(val);
            setStateCode('');
          }
        }}
      />
      <DropdownRegion
        className="form-control"
        autoComplete="address-level1"
        name="region"
        country={countryCode}
        value={stateCode}
        onChange={(val) => setStateCode(val)}
      />
      <input
        className="form-control"
        placeholder="City"
        autoComplete="address-level2"
        name="city"
        value={city}
        onChange={(e) => setCity(e.target.value)}
      />
      <input
        className="form-control"
        placeholder="Postal code"
        autoComplete="postal-code"
        name="postal"
        value={postalCode}
        onChange={(e) => setPostalCode(e.target.value)}
      />
      <div className="calc-subnote">
        * Carriers use the larger of actual and volumetric weights for their rates.<br/>
        ** Many carriers also round up to the next lb or 0.5 kg.
      </div>
      <div className="calc-subnote">
        * The rates displayed are estimates only, and are subject to change without prior notice.
      </div>
      <div className="calc-label">From your mailbox in...</div>
      <div className="calc-warehouses">
        <div className="apr-new-store-flags">
          {warehouses.map(w => (
            <div
              className={`apr-new-store-flag ${w.id === warehouse ? 'apr-new-store-flag-active' : ''}`}
              onClick={() => setWarehouse(w.id)}
              key={w.id}
            >
              <img className="apr-new-store-flag-img" src={`/assets/images/${w.flag}`} alt={w.name}/>
              <div className="apr-new-store-name">{w.name}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="calc-buttons">
        <div
          className="btn btn-primary"
          onClick={loading ? () => {
          } : doRequestQuotes}
        >
          {loading ? <ButtonLoading/> : 'Get Shipping Estimates'}
        </div>
      </div>
    </div>
  )

  const notificationMessage = (
    <div className="calc-mid">

      {!!message && <div className="ship-quotes-none">
        Whoops! It looks like we’re having trouble finding an appropriate shipping method for your address. There
        are several reasons why this might be happening, including: <br/><br/>
        <ul>
          <li>• Our shipping partners may not service your location.</li>
          <li>• Your address may be on the government blacklists that we cross-reference before shipping.</li>
          <li>• Your package may require special handling due to size, weight, or contents.</li>
        </ul>
        Please contact our support team via the chat tool on our website so that we can make special arrangements
        for shipping your package.
      </div>}

      {!!isRecaptcha2Required && (
        <div className="form-group">
          <RecaptchaV2 onVerify={onVerifyRecaptchaV2}/>
        </div>
      )}

    </div>
  )

  const shippingQuoteList = (shippingOptions) => {
    if (submitted && !shippingOptions.length) {
      return (
        <div className="calc-mid">
          <div className="ship-quote-message">
            Sorry, there are no regular shipping options available for your package and destination.
            Please contact us for special shipment handling.
          </div>
        </div>
      )
    }

    return (
      <div className="calc-mid">
        <div className="ship-quotes">
          {shippingOptions.map((option, index) => (
            <div className="ship-quote card card-package card-white" key={index}>
              {option.ddp.enabled && <div className="ddp-tag">Duty Delivery Paid</div>}
              <div className="ship-quote-info">
                <div className="ship-quote-title">{option.displayName}</div>
                {option.deliveryDays.amount ? (
                  <div className="ship-quote-time">Estimate {option.deliveryDays.amount} Business Days</div>
                ) : (
                  <div className="ship-quote-time">
                    {option?.serviceDescription || 'Delivery time depends on destination and cannot be guaranteed'}
                  </div>
                )}
              </div>
              <div className="ship-quote-price">
                {option.amount ? <Fragment>${option.amount}</Fragment> : 'Free'}
              </div>
            </div>
          ))}
        </div>
      </div>

    )
  }

  const shippingQuoteList2 = (shippingOptions) => {
    if (shippingOptions.length === 1 && shippingOptions[0].displayName === 'Provide Own Label') {
      return (
        <div className="calc-mid">
          <div className="ship-quotes-none">
            Sorry, there are no regular shipping options available for your package and destination.
            Please contact us for special shipment handling.
          </div>
        </div>
      )
    }

    const shippingOptionsWithoutOwnLabel = shippingOptions.filter(option => option.displayName !== 'Provide Own Label')

    const calculateRates = (platinumRate) => {
      if (!platinumRate) return { free: 'Free', gold: 'Free', platinum: 'Free' }
      const platinum = Number(platinumRate)
      const gold = (platinum * 1.1).toFixed(2)
      const free = (platinum * 1.2).toFixed(2)
      return { free, gold, platinum: platinumRate }
    }
  
    return (
      <div className="calc-mid">
        <div className="ship-quotes">
          {shippingOptionsWithoutOwnLabel.map((option, index) => (
            <div className="ship-quote card card-package card-white" key={index}>
              {option?.ddp?.enabled && <div className="ddp-tag">Duty Delivery Paid</div>}
              <div className="ship-quote-info">
                <div className="ship-quote-title">{option.displayName}</div>
                {option.deliveryDays?.amount ? (
                  <div className="ship-quote-time">Estimate {option.deliveryDays.amount} Business Days</div>
                ) : (
                  <div className="ship-quote-time">
                    {option?.serviceDescription || 'Delivery time depends on destination and cannot be guaranteed'}
                  </div>
                )}
              </div>
              <div className="ship-quotes-plan-rates">
                {(() => {
                  const rates = calculateRates(option.amount)
                  return (
                    <>
                      <div className="ship-quotes-plan-column">
                        <div className="ship-quotes-plan-tag ship-quotes-plan-tag-free">Free</div>
                        <div className="ship-quotes-plan-rate">${rates.free}</div>
                      </div>
                      <div className="ship-quotes-plan-column">
                        <div className="ship-quotes-plan-tag ship-quotes-plan-tag-gold">Gold</div>
                        <div className="ship-quotes-plan-rate">${rates.gold}</div>
                      </div>
                      <div className="ship-quotes-plan-column">
                        <div className="ship-quotes-plan-tag ship-quotes-plan-tag-platinum">Platinum</div>
                        <div className="ship-quotes-plan-rate">${rates.platinum}</div>
                      </div>
                    </>
                  )
                })()}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const handlePanelChange = (key) => {
    setUserInput('')
    setDisplayText('')
    setSubmitted(false)
    setShippingOptions([])
    setCleanupMessage('')
    setActivePanel(key.length ? key[0] : activePanel)
  }

  const signUpAction = (
    <div className="signup-action">
      <Link to="/plans" className="signup-action-link">
        Learn more about our rates and membership plans
      </Link>
    </div>
  )

  return (
      <div className="calc-wrapper2">
        <div className="calc-collapse">
          <Collapse 
            activeKey={[activePanel]} 
            onChange={handlePanelChange} 
            ghost 
            accordion
          >
            <Panel header="Describe your shipping request" key="1">
              <div className="calc-panel-content">
                {aiForm}
                {typingTextElement}
                {activePanel === '1' && listType === 2 && shippingQuoteList2(shippingOptions)}
                {activePanel === '1' && listType === 1 && shippingQuoteList(shippingOptions)}
                {!!shippingOptions.length && signUpAction}
              </div>
            </Panel>
            <Panel header="OR Provide package details" key="2">
              <div className="calc-panel-content">
                {oldForm}
                {activePanel === '2' && shippingQuoteList(shippingOptions)}
                {notificationMessage}
                {!!shippingOptions.length && signUpAction}
              </div>
            </Panel>
          </Collapse>
        </div>
    </div>
  )
}

const TypingText = ({ text, speed }) => {
  const [displayedText, setDisplayedText] = useState('')
  const intervalRef = useRef(null)
  const indexRef = useRef(0)
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    indexRef.current = 0;
    setDisplayedText('');
    
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      if (!mounted.current) return;
      
      if (indexRef.current < text.length) {
        setDisplayedText(current => current + text[indexRef.current]);
        indexRef.current++;
      } else {
        clearInterval(intervalRef.current);
      }
    }, speed);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [text, speed]);

  return <div className="calc-typing-text">{displayedText}</div>;
};

export default connect(mapStateToProps)(withRouter(withGoogleReCaptcha(PublicCalculator)));
